import React from 'react'
import { Box, Text, BoxProps } from 'theme-ui'
import panel from '../../theme/panel'

interface PanelComponentProps extends BoxProps {
  header?: string
  variant?: keyof typeof panel.header
  childPadding?: string | number | Array<string | number>
}

export function PanelComponent({
  variant = 'primary',
  children,
  ...props
}: PanelComponentProps) {
  return (
    <Box {...props}>
      <Box sx={{ variant: `panel.header.${variant}` }}>
        <Text sx={{ ml: '4', fontWeight: 'bold' }}>{props.header}</Text>
      </Box>
      <Box
        sx={{
          variant: `panel.content.${variant}`,
          padding: props.childPadding,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
